<script setup>
import SectionViewer from '../../components/SectionViewer.vue'

// Define sections
const sections = [
  { id: 'info-ninos', title: '8.1 Información para niños, niñas y adolescentes' },
  { id: 'info-mujeres', title: '8.2 Información para Mujeres' }
]
</script>

<template>
  <SectionViewer :sections="sections" title="8. Información específica para Grupos de Interés" />
</template>
